/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgradeRuleResponseChainingRules
 */
export interface UpgradeRuleResponseChainingRules {
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponseChainingRules
     */
    loaderVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponseChainingRules
     */
    fwVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponseChainingRules
     */
    uiVersion?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgradeRuleResponseChainingRules
     */
    id?: string;
    /**
     * 
     * @type {number}
     * @memberof UpgradeRuleResponseChainingRules
     */
    orderIndex?: number;
}

export function UpgradeRuleResponseChainingRulesFromJSON(json: any): UpgradeRuleResponseChainingRules {
    return UpgradeRuleResponseChainingRulesFromJSONTyped(json, false);
}

export function UpgradeRuleResponseChainingRulesFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgradeRuleResponseChainingRules {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'loaderVersion': !exists(json, 'loaderVersion') ? undefined : json['loaderVersion'],
        'fwVersion': !exists(json, 'fwVersion') ? undefined : json['fwVersion'],
        'uiVersion': !exists(json, 'uiVersion') ? undefined : json['uiVersion'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'orderIndex': !exists(json, 'orderIndex') ? undefined : json['orderIndex'],
    };
}

export function UpgradeRuleResponseChainingRulesToJSON(value?: UpgradeRuleResponseChainingRules | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'loaderVersion': value.loaderVersion,
        'fwVersion': value.fwVersion,
        'uiVersion': value.uiVersion,
        'id': value.id,
        'orderIndex': value.orderIndex,
    };
}

